<template>
  <div class="container-flex element">
    <div class="container">
      <h2 class="h2 section-title underline contactus">CONTACT US</h2>
      <div class="data-contact">

        <div class="contact-form">
          <form @submit.prevent="enviarEmail">
            <div class="form-group">
              <input type="text" name="website" style="display:none">
              <input type="text" placeholder="Name" v-model="name" required>
            </div>
            <div class="form-group">
              <input type="email" placeholder="Email" v-model="email" required>
            </div>
            <div class="form-group">
              <textarea rows="5" v-model="message" required placeholder="Message"></textarea>
            </div>

            <button type="submit">Send Message</button>
          </form>
        </div>

        <div class="contact">
          <div class="contact-info">
            <p><strong>Address:</strong> Rua Ilha do Sal, nº 7, POR TRAS Palmarejo - Praia Santiago, Cabo Verde</p>
            <p><strong>Phone:</strong> +238 262 05 00 / +238 919 0840</p>
            <p style="display: flex;"><strong>Email:</strong>
              <a href="mailto:geral@360spr.cv" style="width: 50%; margin-left: 1%;">geral@360spr.cv</a>  
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'

// Variáveis vinculadas ao formulário
const name = ref('')
const email = ref('')
const message = ref('')

const enviarEmail = async () => {
  try {
    const response = await axios.post(
      'https://360spr.cv/api/enviaremail.php',
      {
        name: name.value,
        email: email.value,
        message: message.value
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )

    alert(response.data)

    // Limpar os campos do formulário
    name.value = ''
    email.value = ''
    message.value = ''

  } catch (error) {
    console.error(error)
    alert('Erro ao enviar o email.')
  }
}
</script>

<style scoped>
.data-contact{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 5%;
    padding: 5%;

}
.container-flex{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--title-color);
    color: white;
}
h2{
    text-align: center;
    color: white;
    margin-top: 2%;
}
.contact-form input, .contact-form textarea{
    width: 100%;
    padding: 10px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
}
.contact{
    width: 40%;
}
.contact-form{
    width: 50%;
}
button{
    background-color: white;
    color: var(--title-color);
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    width: 45%;
    transition: background-color 0.3s ease;
    font-weight: bold;
}
input{
    background-color: transparent;
    border: 1px solid var(--menu-color);
    color: white;
}
input:focus:focus{
    border-color: var(--menu-color);
    outline: none;
    color: white;
}

.section-title{
    margin-bottom: 0 !important;
}
@media (max-width: 767px) {
    .contact-form{
        width: 100%;
    }



button{
    width: 100%;
    margin-bottom: 2%;
}

}

</style>
